import { Phone, Mail, MapPin, UserRound, Navigation } from "lucide-react";
import { usePageTitle } from "@/lib/api";
import { SITE, IMG, directionsUrl } from "@/lib/content";
import { PageHero, MapEmbed } from "@/components/site/Bits";
import { InquiryForm } from "@/components/site/InquiryForm";

const info = [
  [UserRound, "President / Program Director", SITE.director],
  [Phone, "Phone", SITE.phone],
  [Mail, "Email", SITE.email],
  [MapPin, "Location", SITE.location],
  [MapPin, "Home Field", `${SITE.field}, ${SITE.address}`],
];

export default function Contact() {
  usePageTitle("Contact Us");
  return (
    <div data-testid="contact-page">
      <PageHero testid="contact-hero" eyebrow="Contact Us" image={IMG.stadium} title={<>Talk to<br /><span className="text-gold">Tri County.</span></>}>
        <div className="mt-8 flex flex-col sm:flex-row gap-4">
          <a href={SITE.tel} className="btn-gold !text-lg" data-testid="contact-call-button"><Phone className="h-5 w-5" /> Call Tri County</a>
          <a href={SITE.mailto} className="btn-line !text-lg" data-testid="contact-email-button"><Mail className="h-5 w-5" /> Email Tri County</a>
        </div>
      </PageHero>
      <section className="bg-pitch py-16 sm:py-24">
        <div className="wrap grid gap-12 lg:grid-cols-[0.9fr_1.1fr]">
          <div>
            <p className="h-display text-4xl">Tri County Allstars</p>
            <dl className="mt-8 space-y-px bg-line/60" data-testid="contact-info">
              {info.map(([Icon, k, v]) => (
                <div key={k} className="bg-pitch py-4 flex gap-4">
                  <Icon className="h-5 w-5 text-gold mt-1 shrink-0" />
                  <div><dt className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-400">{k}</dt><dd className="font-display text-xl font-extrabold uppercase break-all sm:break-normal">{v}</dd></div>
                </div>
              ))}
            </dl>
            <a href={directionsUrl()} target="_blank" rel="noreferrer" className="mt-6 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-gold hover:text-white" data-testid="contact-directions-link"><Navigation className="h-4 w-4" /> Directions to PSLAA</a>
          </div>
          <div>
            <p className="eyebrow mb-4">Send a Message</p>
            <InquiryForm type="contact" prefix="contact" />
          </div>
        </div>
      </section>
      <MapEmbed className="h-96" />
    </div>
  );
}
